import { useState } from "react";
import { copyCodeTexts } from "./constants/templateConstants";

const TemplateButtons = ({ buttons, setButtons, language }) => {
  const addButton = () => {
    setButtons([...buttons, { type: "QUICK_REPLY", text: "" }]);
  };

  const handleButtonChange = (index, field, value) => {
    const updatedButtons = [...buttons];
    updatedButtons[index][field] = value;
    setButtons(updatedButtons);
  };

  const removeButton = (index) => {
    setButtons(buttons.filter((_, i) => i !== index));
  };

  return (
    <div className="cx-template-section">
      <h5 className="cx-template-section-title">
        <i className="bi bi-ui-buttons me-2"></i>
        Buttons (Optional)
      </h5>
      
      <div className="cx-template-buttons">
        {buttons.map((button, index) => (
          <div key={index} className="cx-template-button-card card mb-3">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <h6 className="card-title mb-0">Button {index + 1}</h6>
                <button
                  type="button"
                  className="btn btn-sm btn-outline-danger"
                  onClick={() => removeButton(index)}
                >
                  <i className="bi bi-trash"></i> Remove
                </button>
              </div>
              
              <div className="row">
                <div className="col-md-6 mb-2">
                  <label className="form-label">Button Type</label>
                  <select
                    className="form-control"
                    value={button.type}
                    onChange={(e) => {
                      const value = e.target.value;
                      handleButtonChange(index, "type", value);
                      if (value === "COPY_CODE") {
                        const fixedText = copyCodeTexts[language] || copyCodeTexts["en"];
                        handleButtonChange(index, "text", fixedText);
                      }
                    }}
                  >
                    <option value="QUICK_REPLY">Quick Reply</option>
                    <option value="URL">URL Button</option>
                    <option value="PHONE_NUMBER">Phone Number</option>
                    <option value="COPY_CODE">Copy Code</option>
                  </select>
                </div>
                
                <div className="col-md-6 mb-2">
                  <label className="form-label required">Button Text</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Button Text"
                    value={button.text}
                    onChange={(e) => handleButtonChange(index, "text", e.target.value)}
                    required
                    readOnly={button.type === "COPY_CODE"}
                  />
                </div>
              </div>
              
              {button.type === "URL" && (
                <div className="mb-2">
                  <label className="form-label required">URL</label>
                  <input
                    type="url"
                    className="form-control"
                    placeholder="https://example.com"
                    value={button.url || ""}
                    onChange={(e) => handleButtonChange(index, "url", e.target.value)}
                    required
                  />
                </div>
              )}
              
              {button.type === "PHONE_NUMBER" && (
                <div className="mb-2">
                  <label className="form-label required">Phone Number</label>
                  <input
                    type="tel"
                    className="form-control"
                    placeholder="+1234567890"
                    value={button.phone_number || ""}
                    onChange={(e) => handleButtonChange(index, "phone_number", e.target.value)}
                    required
                  />
                </div>
              )}
              
              {button.type === "COPY_CODE" && (
                <div className="mb-2">
                  <label className="form-label required">Coupon Code</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="WELCOME20"
                    value={button.coupon_code || ""}
                    onChange={(e) => handleButtonChange(index, "coupon_code", e.target.value)}
                    required
                  />
                </div>
              )}
            </div>
          </div>
        ))}
        
        {buttons.length < 10 && (
          <button
            type="button"
            className="btn btn-outline-primary"
            onClick={addButton}
          >
            <i className="bi bi-plus-circle me-2"></i>
            Add Button
          </button>
        )}
        
        {buttons.length > 0 && (
          <div className="form-text mt-2">
            {10 - buttons.length} buttons remaining
          </div>
        )}
      </div>
    </div>
  );
};

export default TemplateButtons;